module.exports = __webpack_public_path__ + "static/video-sift-result-1-b9aad2e31a86f09e7f8f0c51a1818aa3.png";